<div class="SLV2-topic-box" id="{{'topic_accro'+rowIndex}}" #topic_accro>
    <div id="topic_div" class="SLV2-topic-header cursor-pointer" (click)="topic_accro.classList.toggle('expand');setExpandRowIndex();">

        <!-- <img src="selflearnv2-ui/assets/img/self-learn-v2/crown-with-bg-icon.svg" class="SLV2-crown-tag" /> -->

            <div class="SLV2-topic-progress-wrap {{cardSubject?.replace(' ','') | lowercase}}">
                <apx-chart [series]="donutchartOptions1.series" [chart]="donutchartOptions1.chart" [labels]="donutchartOptions1.labels"
                    [dataLabels]="donutchartOptions1.dataLabels" [legend]="donutchartOptions1.legend"
                    [responsive]="donutchartOptions1.responsive" [tooltip]="donutchartOptions1.tooltip" [fill]="donutchartOptions1.fill"
                    [stroke]="donutchartOptions1.stroke" [states]="donutchartOptions1.states"
                    [plotOptions]="donutchartOptions1.plotOptions" class="apx-donut-chart"></apx-chart>
            </div>
            <div class="SLV2-topic-info">
                <h4 class="SLV2-topic-info-heading">{{topicData?.topicName}}</h4>
                <h5 class="SLV2-topic-info-subheading" [ngClass]="{'SLV2-green-text': topicData?.isCompleted}"><img src="selflearnv2-ui/assets/img/self-learn-v2/green-tick.svg" *ngIf="topicData.isCompleted" />{{topicData.videoCount}} videos, 1 exercise, {{ convertMinutestoHHmm(topicData.durationInSeconds)}}</h5>
            </div>
            <button class="SLV2-topic-accro-btn"><img src="selflearnv2-ui/assets/img/self-learn-v2/down-arrow-icon.svg" /></button>
    </div>


    <div class="SLV2-topic-body-area" *ngIf="topicData.videos.length >0">
        <!-- <app-no-content-card></app-no-content-card> -->
        <ul class="SLV2-topic-list">    
            <li *ngFor="let topic of topicData.videos">
                <div class="SLV2-topic-list-box" [ngClass]="[topic.isCompleted ? 'completed' : '', topic?.isLastWatch && !topic.isCompleted  ? 'resume' : '']" (click)="navigateToVideoPlaybackScreen(topic.videoId)">
                    <div class="SLV2-topic-info-left-col">
                        <div class="SLV2-topic-icon-wrap">
                            <img *ngIf="!topic.isCompleted" src="selflearnv2-ui/assets/img/self-learn-v2/video-icon.svg"/>
                            <img *ngIf="topic.isCompleted" src="selflearnv2-ui/assets/img/self-learn-v2/green-tick.svg" class="complete" />
                        </div>
                        <div class="SLV2-topic-info">
                            <h4 class="SLV2-topic-info-heading">{{topic?.title}}</h4>
                            <h5 class="SLV2-topic-info-subheading" >{{convertMinutestoHHmm(topic?.duration ? topic?.duration : 0) == '0s' ? '--' : convertMinutestoHHmm(topic?.duration ? topic?.duration : 0) }}</h5>
                        </div>
                    </div>
                    <div class="SLV2-topic-info-right-col">
                        <div >
                            <button class="SLV2-topic-bookmark-btn" *ngIf="topic?.isBookmarked">
                                <img src="selflearnv2-ui/assets/img/self-learn-v2/bookmark-icon.svg" />
                            </button>
                        </div>
                        <button *ngIf="topic?.watchedContentInSecs > 0 && topic.isCompleted == false" (click)="navigateToVideoPlaybackScreen(topic.videoId)" class="SLV2-topic-blue-link">Resume</button>
                    </div>
                    <!-- <img src="selflearnv2-ui/assets/img/self-learn-v2/crown-with-bg-icon.svg" class="SLV2-crown-tag" /> -->
                </div>
            </li>




            <li>
                <div class="SLV2-topic-list-box" [ngClass]="topicData?.isexerciseCompleted ? 'completed' : ''" (click)="openExerciseStartDialog()">
                    <div class="SLV2-topic-info-left-col">
                        <div class="SLV2-topic-icon-wrap">
                            <img *ngIf="!topicData?.isexerciseCompleted" src="selflearnv2-ui/assets/img/self-learn-v2/document-icon.svg" class="document" />
                            <img  *ngIf="topicData?.isexerciseCompleted" src="selflearnv2-ui/assets/img/self-learn-v2/green-tick.svg" class="complete" />
                        </div>
                        <div class="SLV2-topic-info" >
                            <h4 class="SLV2-topic-info-heading">Exercise</h4>
                            <!-- <h5 class="SLV2-topic-info-subheading">10 Questions</h5> -->
                        </div>
                    </div>
                    <div class="SLV2-topic-info-right-col">
                    </div>
                    <!-- <img src="selflearnv2-ui/assets/img/self-learn-v2/crown-with-bg-icon.svg" class="SLV2-crown-tag" /> -->
                </div>
            </li>



        </ul>
    </div>
    <ng-container *ngIf="topicData.videos.length <= 0">
        <app-no-content-card></app-no-content-card>
    </ng-container>

</div>


<!-- {{cardSubject}}{{topicData | json}}<br> -->
